var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.roles_list),function(role,key){return _c('v-flex',{key:key,staticClass:"role",attrs:{"xs12":"","sm12":"","md12":""}},[_c('RoleForm',{attrs:{"role":role,"remove":_vm.remove},on:{"remove":_vm.fnRemove}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }